import type {AppserverDataBackedExemplarAvailability, DocumentAvailability, Rec} from 'src/typings';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export default class AvailabilityDataService {
    public static readonly serviceName = 'availabilityDataService'

    private static readonly AVAILABILITY_ROUTE = 'availability';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getByDocumentAndRequester(record: Rec, requesterId: number): Promise<DocumentAvailability> {
        return this.ajaxService
                   .createRequest(`${AvailabilityDataService.AVAILABILITY_ROUTE}`)
                   .get({
                       document: record.id,
                       requester: requesterId
                   });
    }

    @ngAsync()
    public async getByExemplarAndRequester(exemplarId: number, requesterId: number): Promise<AppserverDataBackedExemplarAvailability> {
        return this.ajaxService
                   .createRequest(`${AvailabilityDataService.AVAILABILITY_ROUTE}`)
                   .get({
                       exemplar: exemplarId,
                       requester: requesterId
                   });
    }
}
